export const createResolvedHubResult = (sentry, createHub, sentryBeforeSend) => ({
  hub: createHub(sentry),
  sentry,
  sentryBeforeSend
});
export const createLazyHubResult = (globalConfig, lazySentry, createHub, sentryBeforeSend) => {
  let resolveFn;
  const promise = new Promise(resolve => {
    resolveFn = resolve;
  });
  const hubResult = {
    // This method should be called when we need to trigger the Sentry lazy loader (for example after using reportError)
    load: () => {
      const sentryLazyLoaderTriggered = globalConfig.getStateValue('sentryLazyLoaderTriggered');
      if (sentryLazyLoaderTriggered) {
        return promise;
      }
      globalConfig.setStateValue('sentryLazyLoaderTriggered', true);
      lazySentry.forceLoad();
      return promise;
    },
    // Call this method when we need to wait for Sentry to be resolved
    wait: () => promise,
    sentryBeforeSend
  };

  // Listen to Sentry loader. The loader can run either because we triggered it or because it was triggered outside of Panorama.
  lazySentry.onLoad(sentry => {
    globalConfig.setStateValue('sentryResolved', sentry);

    // Resolve any awaiting consumers with the original lazy object augmented with the resolved values
    resolveFn(Object.assign(hubResult, createResolvedHubResult(sentry, createHub, sentryBeforeSend)));
  });
  return hubResult;
};
export const loadLazyHub = hubResult => hubResult.load();
export const waitForLazyHub = hubResult => hubResult.wait();
export const isLazySentry = hubResult => !hubResult.BrowserClient;
export const isHubInvalid = hubResult => hubResult.hub === null;
export const isHubResolved = hubResult => !!hubResult.hub;
//# sourceMappingURL=sentry-plugin-hub-utils.js.map